import React, { useState } from "react";
import { useSelector } from "react-redux";
import TabItem from "../../components/TabItem";
import MasterDashboard from "./master-dashboard";
import ByPerson from "./by-person";
import ByProjectHighConfidence from "./by-project-high-confidence";
import UnpaidActivities from "./unpaid-activities";
import PaidActivities from "./paid-activities";
const MASTER_DASHBOARD = "MASTER_DASHBOARD";
const BY_PERSON = "BY_PERSON";
const BY_PROJECT_HIGH_CONFIDENCE = "BY_PROJECT_HIGH_CONFIDENCE";
const UNPAID_ACTIVITIES = "UNPAID_ACTIVITIES";
const PAID_ACTIVITIES = "PAID_ACTIVITIES";

export default function Brain() {
  const [activeTab, setActiveTab] = useState(MASTER_DASHBOARD);
  const businessUnit = useSelector((state) => state.Auth.businessUnit);

  return (
    <div className="bg-white h-full">
      <div className="border-b border-gray-200">
        <TabItem title="Dashboard" tab={MASTER_DASHBOARD} onClick={() => setActiveTab(MASTER_DASHBOARD)} active={activeTab === MASTER_DASHBOARD} />
        <TabItem title="Occupation" tab={BY_PERSON} onClick={() => setActiveTab(BY_PERSON)} active={activeTab === BY_PERSON} />
        <TabItem title="High Confidence" tab={BY_PROJECT_HIGH_CONFIDENCE} onClick={() => setActiveTab(BY_PROJECT_HIGH_CONFIDENCE)} active={activeTab === BY_PROJECT_HIGH_CONFIDENCE} />
        <TabItem title="Unpaid Activities" tab={UNPAID_ACTIVITIES} onClick={() => setActiveTab(UNPAID_ACTIVITIES)} active={activeTab === UNPAID_ACTIVITIES} />
        <TabItem title="Paid Activities" tab={PAID_ACTIVITIES} onClick={() => setActiveTab(PAID_ACTIVITIES)} active={activeTab === PAID_ACTIVITIES} />
      </div>
      <div className="p-4">
        {activeTab === MASTER_DASHBOARD && <MasterDashboard key={businessUnit._id} businessUnit={businessUnit} />}
        {activeTab === BY_PERSON && <ByPerson key={businessUnit._id} businessUnit={businessUnit} />}
        {activeTab === BY_PROJECT_HIGH_CONFIDENCE && <ByProjectHighConfidence key={businessUnit._id} businessUnit={businessUnit} />}
        {activeTab === UNPAID_ACTIVITIES && <UnpaidActivities key={businessUnit._id} businessUnit={businessUnit} />}
        {activeTab === PAID_ACTIVITIES && <PaidActivities key={businessUnit._id} businessUnit={businessUnit} />}
      </div>
    </div>
  );
}
